import DynamicFormConfiguration from 'modules/admin/components/DynamicFormConfiguration'

export default DynamicFormConfiguration
